import { getBase64 } from "@/global";
import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    configAprendizes: null,
    areasInteresse: [],
    dialogManutExpProf: false,
    candidato: null,
    aprendiz_industrial: false,
    generos: [],
    cutis: [],
    nacionalidades: [],
    locais: [],
    categorias_cnh: [],
    acesso: {
      cpf: "",
      dtnasc: "",
    },
    loadingApp: true,
    experiencia: null,
    anexos: {
      certificado_conclusao: null,
      comprovante_residencia: null,
      cpf: null,
      rg_frente: null,
      rg_verso: null,
      historico_escolar: null,
      qualificacao_cadastral: null,
      cnh: null,
    },
    empresas_func: [],
    inscricao: {
      id: 0,
      nivel: 0,
      cpf: "",
      imgCPFFrente: null,
      imgCPFFrenteInfo: false,
      imgCPFFrenteConvert: "",
      dtnasc: "",
      nome: "",
      rg: "",
      imgRGFrente: null,
      imgRGFrenteInfo: false,
      imgRGFrenteConvert: "",
      imgRGVerso: null,
      imgRGVersoInfo: false,
      imgRGVersoConvert: "",
      pais: "BRA",
      uf: "",
      cidade: "",
      endereco: "",
      numero: "",
      bairro: "",
      cep: "",
      imgcomprovresid: null,
      imgcomprovresidInfo: false,
      imgcomprovresidConvert: "",
      telefone1: "",
      telefone2: "",
      sexo: 0,
      naturalidade: 0,
      codescolaridade: 0,
      imgescola: null,
      imgescolaConvert: "",
      numerocnh: "",
      categoriacnh: 0,
      dtvalidcnh: "",
      imgcnh: null,
      imgcnhInfo: false,
      imgcnhConvert: "",
      deficiencias: [],
      areasinteresse: [],
      anexos: [],
      msgcandidato: "",
      imgqualificacao: null,
      imgqualificacaoInfo: false,
      imgqualificacaoConvert: "",
      podeeditar: false,
      imgHistEscolar: null,
      imgHistEscolarInfo: false,
      imgHistEscolarConvert: "",
      peso: "",
      altura: "",
      des_curso_trein: "",
    },
    edit: true,
    step: 1,
    deficiencias: ["Física", "Auditiva", "Visual", "Mental"],
    escolaridades: [],
    cursosSuperiores: [],
    paises: [],
    ufs: [],
    cidades: [],
    areasSelecionadas: [],
    categorias: [],
  };
};

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    addStep(state) {
      state.step++;
    },
    backStep(state) {
      state.step--;
    },
    setStep(state, stp) {
      state.step = stp;
    },
    setEdit(state, edt) {
      state.edit = edt;
    },
    setEscolaridades(state, data) {
      state.escolaridades = data;
    },
    setCursosSuperiores(state, lista) {
      state.cursosSuperiores = lista;
    },
    setPaises(state, paises) {
      state.paises = paises;
    },
    setUfs(state, ufs) {
      state.ufs = ufs;
    },
    setCidades(state, data) {
      state.cidades = data;
    },
    setCategorias(state, data) {
      state.categorias = data;
    },
    setAreasSelecionadas(state, data) {
      state.areasSelecionadas = data;
    },
    addAnexo(state, anexo) {
      state.inscricao.anexos.push(anexo);
    },
    delAnexo(state, pos) {
      state.inscricao.anexos.splice(pos, 1);
    },
    setConfigAprendizes(state, value) {
      state.configAprendizes = value;
    },
    setAreasInteresse(state, value) {
      state.areasInteresse = value;
    },
    setDialogManutExpProf(state, value) {
      state.dialogManutExpProf = value;
    },
    setGeneros(state, value) {
      state.generos = value;
    },
    setCutis(state, value) {
      state.cutis = value;
    },
    setNacionalidades(state, value) {
      state.nacionalidades = value;
    },
    setLocais(state, value) {
      state.locais = value;
    },
    setExperiencia(state, value) {
      state.experiencia = Object.assign({ ...value });
    },
    resetStateExpProf(state) {
      state.experiencia = {
        empresa: "",
        admissao: "",
        desligamento: "",
        cargo: "",
        pais: "BRA",
        uf: "PR",
        desc_cidade: "",
        cidade: 0,
      };
    },
    setAcesso(state, value) {
      state.acesso = value;
    },
    // setCandidato(state, value) {
    //   state.candidato = value;
    // },
    setCandidato(state, value) {
      if (value) {
        value.podeeditar =
          value.log_perm_atualiz_site !== undefined
            ? value.log_perm_atualiz_site
            : false;
      }
      state.candidato = value;
    },
    setLoadingApp(state, value) {
      state.loadingApp = value;
    },
    setCategoriasCNH(state, value) {
      state.categorias_cnh = value;
    },
    setEmpresasFunc(state, value) {
      state.empresas_func = value;
    },
  },
  actions: {
    async getEscolaridades(context) {
      context.commit("setEscolaridades", []);
      await axios.get("/trabalhe-conosco/escolaridades").then((res) => {
        if (res.data.success) context.commit("setEscolaridades", res.data.data);
      });
    },
    async getCursosSuperiores({ commit }) {
      commit("setCursosSuperiores", []);
      try {
        const res = await axios.get(
          `/trabalhe-conosco/escolaridades?funcao=CURSOS-SUPERIORES`,
        );
        // agora res.data é direto um Array [{codigo,descricao},…]
        commit("setCursosSuperiores", res.data.data);
      } catch (err) {
        console.error("Erro ao carregar cursos superiores:", err);
      }
    },
    async getDadosGerais(context) {
      context.commit("setGeneros", []);
      context.commit("setCutis", []);
      context.commit("setNacionalidades", []);
      context.commit("setLocais", []);
      context.commit("setCategoriasCNH", []);
      await axios.get("/trabalhe-conosco/dados-gerais").then((res) => {
        if (res.data.success) {
          context.commit("setGeneros", res.data.data.generos);
          context.commit("setCutis", res.data.data.cutis);
          context.commit("setNacionalidades", res.data.data.nacionalidades);
          context.commit("setLocais", res.data.data.locais);
          context.commit("setCategoriasCNH", res.data.data.categorias_cnh);
        }
      });
    },

    async refreshCandidato(context) {
      context.commit("setLoadingApp", true);
      context.commit("setCandidato", null);
      context.commit(
        "setAcesso",
        JSON.parse(sessionStorage.getItem("candidato")),
      );

      context.state.aprendiz_industrial = false;
      if (sessionStorage.getItem("aprendiz-industrial")) {
        context.state.aprendiz_industrial = true;
      }

      if (context.state.acesso != null && context.state.acesso != undefined) {
        var res = await context.dispatch("getInscricaoCandidato");
        if (res.status == 200) {
          if (res.data.success) {
            let candidatoData = res.data.data;

            if (candidatoData.log_perm_atualiz_site !== undefined) {
              candidatoData.podeeditar = candidatoData.log_perm_atualiz_site;
            } else {
              candidatoData.podeeditar = false;
            }

            context.commit("setCandidato", candidatoData);
          } else {
            context.commit("setCandidato", null);
            Vue.toasted.error(res.data.msg);
          }
        }
      } else {
        context.commit("setAcesso", { cpf: "", dtnasc: "" });
      }

      context.commit("setLoadingApp", false);
    },
    async getInscricaoCandidato(context) {
      return await axios.post(
        "/trabalhe-conosco/consultar-inscricao",
        JSON.stringify(context.state.acesso),
      );
    },
    async getCategorias(context) {
      context.commit("setCategorias", []);
      await axios.get("/trabalhe-conosco/categorias-cnh").then((res) => {
        if (res.data.success) context.commit("setCategorias", res.data.data);
      });
    },
    async getAreasInteresse(context) {
      context.commit("setAreasInteresse", []);
      await axios.get("/trabalhe-conosco/areas-interesse").then((res) => {
        if (res.data.success)
          context.commit("setAreasInteresse", res.data.data);
      });
    },
    async getConfigAprendizes(context) {
      context.commit("setConfigAprendizes", null);
      await axios.get("/curriculos/config-aprendizes").then((res) => {
        if (res.data.success) {
          context.commit("setConfigAprendizes", res.data.data);
        }
      });
    },
    async converterAnexos(context) {
      if (context.state.anexos.certificado_conclusao != null) {
        context.state.candidato.imgescolaConvert = await getBase64(
          context.state.anexos.certificado_conclusao,
        );
      }

      if (context.state.anexos.comprovante_residencia != null) {
        context.state.candidato.imgcomprovresidConvert = await getBase64(
          context.state.anexos.comprovante_residencia,
        );
      }

      if (context.state.anexos.cpf != null) {
        context.state.candidato.imgCPFFrenteConvert = await getBase64(
          context.state.anexos.cpf,
        );
      }

      if (context.state.anexos.rg_frente != null) {
        context.state.candidato.imgRGFrenteConvert = await getBase64(
          context.state.anexos.rg_frente,
        );
      }

      if (context.state.anexos.rg_verso != null) {
        context.state.candidato.imgRGVersoConvert = await getBase64(
          context.state.anexos.rg_verso,
        );
      }

      if (context.state.anexos.historico_escolar != null) {
        context.state.candidato.imgHistEscolarConvert = await getBase64(
          context.state.anexos.historico_escolar,
        );
      }

      if (context.state.anexos.qualificacao_cadastral != null) {
        context.state.candidato.imgqualificacaoConvert = await getBase64(
          context.state.anexos.qualificacao_cadastral,
        );
      }

      if (context.state.anexos.cnh != null) {
        context.state.candidato.imgcnhConvert = await getBase64(
          context.state.anexos.cnh,
        );
      }
    },
    async confirmarInscricao(context) {
      await context.dispatch("converterAnexos");

      try {
        context.state.candidato.peso = parseFloat(context.state.candidato.peso);
        context.state.candidato.altura = parseFloat(
          context.state.candidato.altura,
        );

        const res = await axios.post(
          "/trabalhe-conosco/criar-inscricao",
          JSON.stringify({ inscricao: context.state.candidato }),
        );

        if (res.data.success) {
          Vue.toasted.success(res.data.msg);
          return true;
        } else {
          Vue.toasted.error(res.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Falha na requisição de inscrição:", error);
        if (error.response) {
          console.error("Status:", error.response.status);
          console.error("Body de erro:", error.response.data);
        }
        Vue.toasted.error(
          error.response?.data?.msg || error.message || "Erro desconhecido",
        );
        return false;
      }
    },

    async getEmpresasFunc(context) {
      context.commit("setEmpresasFunc", []);
      await axios.get("/trabalhe-conosco/empresas-func").then((res) => {
        if (res.data.success) {
          context.commit("setEmpresasFunc", res.data.data);
        }
      });
    },
    abrirWhatsapp() {
      window.open(
        "https://wa.me/5546999851826?text=Ol%C3%A1%2C+gostaria+de+saber+mais+informa%C3%A7%C3%B5es+sobre+vagas+na+cooperativa.",
        "_blank",
      );
    },
  },
  getters: {
    isSelecExterior(state) {
      return state.inscricao.pais == "EXTERIOR";
    },
    /*isSelecMotora(state) {
      return (
        state.areasSelecionadas.filter((a) =>
          a.toLowerCase().includes("motorista")
        ).length > 0
      );
    },*/
  },
});
